export type PopoverElements = {
  trigger: HTMLElement
  popover: HTMLElement
  search: HTMLElement | null
}

export type Popover = {
  isOpen(): boolean
  open(): boolean
  close(): void
}

export const createPopover = (elements: PopoverElements): Popover => {
  const isOpen = (): boolean => elements.popover.matches(':popover-open')

  const setExpanded = (value: 'true' | 'false'): void => {
    elements.trigger.setAttribute('aria-expanded', value)
    elements.search?.setAttribute('aria-expanded', value)
  }

  const open = (): boolean => {
    if (isOpen()) return false

    elements.popover.showPopover()
    setExpanded('true')
    elements.search?.focus()

    return true
  }

  const close = (): void => {
    if (isOpen()) elements.popover.hidePopover()

    setExpanded('false')
    elements.search?.removeAttribute('aria-activedescendant')
  }

  return { isOpen, open, close }
}
